// extracted by mini-css-extract-plugin
module.exports = {"actions":"vendor-actions_actions__2WsCg"};